import { Scheme_fromCardSchemeGql } from "@npco/zeller-design-system";
import { twMerge } from "tailwind-merge";

import { TransactionStatus } from "../../../../../../schema.dev-sdk-api-appsync.generated";
import { formatCurrency } from "../../../../../@lib-i18n";
import { formatTimestamp } from "../../../../../@lib-i18n/format-datetime";
import type { Transaction } from "../get-transaction";
import { getMethod } from "../shared/transaction-utils";

export const RefundTransactionsListItem = ({
	amount,
	currency,
	maskedPan,
	scheme: transactionScheme,
	timestamp,
	status,
}: NonNullable<Transaction["refundTransactions"]>[number]) => {
	const scheme = Scheme_fromCardSchemeGql(transactionScheme);
	const statusColor = statusColorMap[status];

	return (
		// NOTE: 62.5px + 1.5px (border) = 64px
		<li className="box-border flex h-[62.5px] w-full list-none items-center pr-8">
			<div
				aria-label={scheme.label}
				className="mx-8 h-[40px] w-[40px] rounded-4"
			>
				{scheme.icon}
			</div>
			<div
				className={twMerge(
					"box-border flex h-full w-full items-center justify-between border-b-[1.5px] border-grey-90 dark:border-grey-800",
				)}
			>
				<div className="flex h-full flex-col justify-center pl-8">
					<div className="text-base">
						{getMethod({ maskedPan, isRefund: true })}
					</div>
					<div className="text-sm text-grey-550 aria-disabled:text-grey-250">
						{formatTimestamp(timestamp)}
					</div>
				</div>

				<div className="flex h-full flex-col justify-center text-right">
					<div className="text-base">
						{formatCurrency({
							amountInCents: amount,
							currency: currency ?? undefined,
						})}
					</div>
					<div className={twMerge("text-xs capitalize", statusColor)}>
						{status.toLocaleLowerCase()}
					</div>
				</div>
			</div>
		</li>
	);
};

const statusColorMap = {
	[TransactionStatus.APPROVED]: "text-green-1600",
	[TransactionStatus.DECLINED]: "text-red-1000",
	[TransactionStatus.PROCESSING]: "text-yellow-1000",
	[TransactionStatus.DELETED]: "text-red-1000",
};
